export default "__VITE_ASSET__c7f76e89__"